import packageInfo from '../../package.json';

export const environment = {
  appVersion: packageInfo.version,
  production: true,
  application: {
    api_base_payment_url: 'https://demopaymentapi.orthopms.com/api/',
    web_base_url:"https://demo.orthopms.com/",
    appInsightsLog: true,
    refreshThreshold: 1500,
    isRefreshToken: false,
    nuveiAPIEnvironment: 'int'
  },
  appInsights: {
    instrumentationKey: '5ab468d8-9dea-4beb-8be2-bf3c5a64cc30'
  }
};
